import { z } from 'zod';

const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_MIN_LENGTH_MESSAGE = `Minimum password length is ${PASSWORD_MIN_LENGTH} characters.`;

export const passwordPolicySchema = z.object({
  passwordSecurityPolicyEnabled: z.literal(true),
  passwordUseMixedCase: z.literal(true),
  passwordMinimumLength: z.number().min(PASSWORD_MIN_LENGTH),
  passwordMinimumDigits: z.number().min(1),
  passwordMinimumSymbols: z.number().min(0),
});

export function createPasswordPolicySchema(policy: Partial<PasswordPolicy> = {}) {
  const passwordPolicySchema = z.object({
    passwordSecurityPolicyEnabled: z.literal(true),
    passwordUseMixedCase: z.literal(true),
    passwordMinimumLength: z
      .number({ message: PASSWORD_MIN_LENGTH_MESSAGE })
      .min(PASSWORD_MIN_LENGTH, PASSWORD_MIN_LENGTH_MESSAGE),
    passwordMinimumDigits: z.number().min(policy.passwordMinimumDigits || 1),
    passwordMinimumSymbols: z.number().min(policy.passwordMinimumSymbols || 0),
  });

  return passwordPolicySchema;
}

export type PasswordPolicyFromSchema = z.infer<ReturnType<typeof createPasswordPolicySchema>>;

export interface PasswordPolicy {
  passwordSecurityPolicyEnabled: boolean;
  passwordUseMixedCase: boolean;
  passwordMinimumLength: number;
  passwordMinimumDigits: number;
  passwordMinimumSymbols: number;
}

export function createPasswordPolicy(policy: Partial<PasswordPolicy> = {}): PasswordPolicy {
  const passwordMinimumLength = policy.passwordMinimumLength || PASSWORD_MIN_LENGTH;

  return {
    passwordSecurityPolicyEnabled: true,
    passwordUseMixedCase: true,
    passwordMinimumLength: passwordMinimumLength < PASSWORD_MIN_LENGTH ? PASSWORD_MIN_LENGTH : passwordMinimumLength,
    passwordMinimumDigits: policy.passwordMinimumDigits || 1,
    passwordMinimumSymbols: policy.passwordMinimumSymbols || 0,
  };
}
